<template>
  <v-container>
    <div id="headersTime">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacao"
                  style="text-align: center;"
                />
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Estrutura Organizacional
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Faturamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Fat. Mês Anterior
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Variação de Fat. Mensal
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Fat. Mês do Ano Anterior
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Variação de Fat. Anual
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Margem Contribuição
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Margem Contr. Mes Anterior
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Margem Cont. Mes Ano Anterior
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in evolucaoVendasSupervisor"
              :key="item.id"
            >
              <!-- Linha principal -->
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento_mes_anterior }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColor(item.variacao_mensal)"
                    dark
                  >
                    {{ item.variacao_mensal }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento_ano_anterior }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColor(item.variacao_anual)"
                    dark
                  >
                    {{ item.variacao_anual }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColorMargemContribuicao(item.margemContribuicao)"
                    dark
                  >
                    {{ item.margemContribuicao }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColorMargemContribuicao(item.margemContribuicaoMesAnterior)"
                    dark
                  >
                    {{ item.margemContribuicaoMesAnterior }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColorMargemContribuicao(item.margemContribuicaoAnoAnterior)"
                    dark
                  >
                    {{ item.margemContribuicaoAnoAnterior }}
                  </v-chip>
                </td>
              </tr>
              <!-- Linha expandida -->
              <tr
                v-if="expanded.includes(index)"
                :key="'expanded-' + item.id"
              >
                <td colspan="10">
                  <div style="overflow-x: auto;">
                    <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                      <thead>
                        <tr>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Estrutura Organizacional
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Faturamento
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Fat. Mês Anterior
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Variação de Fat. Mensal
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Fat. Mês do Ano Anterior
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Variação de Fat. Anual
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Margem Contribuição
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Margem Contr. Mes Anterior
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Margem Cont. Mes Ano Anterior
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(sub, idx) in item.evolucaoVendasVendedores"
                          :key="idx"
                        >
                          <td
                            id="dadoMovimentacao"
                            style="text-align: left;"
                          >
                            {{ sub.nome }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ sub.faturamento }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ sub.faturamento_mes_anterior }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColor(sub.variacao_mensal)"
                              dark
                            >
                              {{ sub.variacao_mensal }}
                            </v-chip>
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ sub.faturamento_ano_anterior }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColor(sub.variacao_anual)"
                              dark
                            >
                              {{ sub.variacao_anual }}
                            </v-chip>
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColorMargemContribuicao(sub.margemContribuicao)"
                              dark
                            >
                              {{ sub.margemContribuicao }}
                            </v-chip>
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColorMargemContribuicao(sub.margemContribuicaoMesAnterior)"
                              dark
                            >
                              {{ sub.margemContribuicaoMesAnterior }}
                            </v-chip>
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColorMargemContribuicao(sub.margemContribuicaoAnoAnterior)"
                              dark
                            >
                              {{ sub.margemContribuicaoAnoAnterior }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Time from '../../../../../services/time3'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendasTime',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      expanded: [],
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      rede: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      vendedores: [],
      evolucaoVendasVendedores: [],
      evolucaoVendasSupervisor: [],
      expandir: false,
    }),

    created () {
      eventEmit.$on('update-time', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-time', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, classificacao, vendedores) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.vendedores = vendedores

        this.showEvolucaoVendas()
      },

      async showEvolucaoVendas () {
        this.loading = true

        this.evolucaoVendasSupervisor = []
        this.expanded = []

        await Time.showDadosEvolucaoTimeVendas(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.classificacao, this.vendedores).then(resposta => {
          if (resposta.data.status) {
            const setPerson = new Set()

            const filterSupervisores = resposta.data.faturamentoSupervisor.filter((person) => {
              const duplicatedPerson = setPerson.has(person.nome_supervisor)
              setPerson.add(person.nome_supervisor)
              return !duplicatedPerson
            })

            this.evolucaoVendasSupervisor = filterSupervisores.map((item) => {
              var listaFaturamentoSupervisor = ({
                nome: item.nome_supervisor,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento_mes_anterior: parseFloat(item.faturamento_mes_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao_mensal: item.variacao_mensal + '%',
                faturamento_ano_anterior: parseFloat(item.faturamento_ano_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao_anual: item.variacao_anual + '%',
                cod_supervisor: item.cod_supervisor,
                icone: item.icone,
                expandir: item.expandir,
                evolucaoVendasVendedores: this.orderVendedores(item.evolucaoVendasVendedores),
                quantidade: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                cmv: item.cmv.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemContribuicao: item.margemContribuicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                quantidadeMesAnterior: item.quantidadeMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                cmvMesAnterior: item.cmvMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemContribuicaoMesAnterior: item.margemContribuicaoMesAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                quantidadeAnoAnterior: item.quantidadeAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                cmvAnoAnterior: item.cmvAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemContribuicaoAnoAnterior: item.margemContribuicaoAnoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
              })

              return listaFaturamentoSupervisor
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.evolucaoVendasSupervisor = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      orderVendedores (value) {
        const setPerson = new Set()

        const filterVendedores = value.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome)
          setPerson.add(person.nome)
          return !duplicatedPerson
        })

        const vendedores = filterVendedores.map((item) => {
          var listaFaturamentoVendedores = ({
            nome: item.nome,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamento_mes_anterior: parseFloat(item.faturamento_mes_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_mensal: item.variacao_mensal + '%',
            faturamento_ano_anterior: parseFloat(item.faturamento_ano_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_anual: item.variacao_anual + '%',
            quantidade: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            cmv: item.cmv.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemContribuicao: item.margemContribuicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            quantidadeMesAnterior: item.quantidadeMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            cmvMesAnterior: item.cmvMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemContribuicaoMesAnterior: item.margemContribuicaoMesAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            quantidadeAnoAnterior: item.quantidadeAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            cmvAnoAnterior: item.cmvAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemContribuicaoAnoAnterior: item.margemContribuicaoAnoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
          })

          return listaFaturamentoVendedores
        })

        return vendedores
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      expandedVendedores (value) {
        if (value.icone === 'mdi-plus') {
          value.expandir = true
          value.icone = 'mdi-minus'
          this.evolucaoVendasVendedores = value.evolucaoVendasVendedores
          this.expandir = true
        } else {
          this.expandir = false
          value.icone = 'mdi-plus'
          value.expandir = false
          this.evolucaoVendasVendedores = []
        }
      },

      getColor (value) {
        if (value < '0%') {
          return 'red'
        } else {
          return 'green'
        }
      },

      getColorMargemContribuicao (value) {
        var porcentagem = value.replace('%', '')

        porcentagem = parseFloat(porcentagem.replace('.', '').replace(',', '.'))

        if (porcentagem < parseFloat(0)) {
          return 'red'
        } else if (porcentagem >= parseFloat(0)) {
          return 'green'
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersTime {
      font-size: 9px;
      width: 100% !important;
    }

    #dadoMovimentacao {
      font-size: 9px;
    }

    .tr-max {
      display:none;
    }
    .tr-min {
      display:table;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersTime {
      font-size: 9px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #headersTime
    font-size: 9px

  .tr-min
    display:none

</style>
